// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../node_modules/css-loader/dist/runtime/api.js";
import ___CSS_LOADER_GET_URL_IMPORT___ from "../node_modules/css-loader/dist/runtime/getUrl.js";
var ___CSS_LOADER_URL_IMPORT_0___ = new URL("data:image/svg+xml,%3Csvg width=%2710%27 height=%276%27 viewBox=%270 0 10 6%27 fill=%27none%27 xmlns=%27http://www.w3.org/2000/svg%27%3E%3Cpath d=%27M1 1l4 4 4-4%27 stroke=%27%23999%27 stroke-width=%271.5%27 stroke-linecap=%27round%27 stroke-linejoin=%27round%27/%3E%3C/svg%3E", import.meta.url);
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
var ___CSS_LOADER_URL_REPLACEMENT_0___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_0___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `/* === Agent Workbench Design Tokens === */
:root {
  --aw-bg: #121212;
  --aw-bg-sidebar: #0b0b0b;
  --aw-bg-elevated: #1a1a1e;
  --aw-bg-card: rgba(25, 25, 35, 0.5);
  --aw-border: #2e2e2e;
  --aw-border-soft: #1f1f23;
  --aw-text: #ffffff;
  --aw-text-secondary: #d1d1d6;
  --aw-text-muted: #9ca3af;
  --aw-text-dim: #666;
  --aw-accent: #8b5cf6;
  --aw-accent-alt: #a855f7;
  --aw-accent-metric: #a78bfa;
  --aw-accent-bg: rgba(139, 92, 246, 0.05);
  --aw-accent-border: rgba(139, 92, 246, 0.2);
  --aw-accent-tag-bg: rgba(168, 85, 247, 0.15);
  --aw-qc: #eab308;
  --aw-ua: #22c55e;
  --aw-radius-sm: 8px;
  --aw-radius-md: 12px;
  --aw-radius-lg: 16px;
  --aw-shadow-subtle: 0 4px 12px rgba(0,0,0,0.1);
  --aw-shadow-medium: 0 4px 15px rgba(0,0,0,0.3);
  --aw-shadow-strong: 0 10px 25px rgba(0,0,0,0.5);
}

/* Utility animations */
@keyframes spin {
  from { transform: rotate(0deg); }
  to { transform: rotate(360deg); }
}

/* Reset */
*, *::before, *::after {
  box-sizing: border-box;
}

html, body, #root {
  margin: 0;
  padding: 0;
  height: 100%;
  overflow: hidden;
}

body {
  margin: 0;
  font-family: 'Inter', -apple-system, BlinkMacSystemFont, 'Segoe UI', Roboto, Oxygen, Ubuntu, Cantarell, 'Fira Sans', 'Droid Sans', 'Helvetica Neue', sans-serif;
  -webkit-font-smoothing: antialiased;
  -moz-osx-font-smoothing: grayscale;
  background: var(--aw-bg);
  color: var(--aw-text);
}

/* ─── App Header (Artstash-style) ─── */
.app-header {
  display: flex;
  align-items: center;
  justify-content: space-between;
  height: 48px;
  padding: 6px 32px;
  background-color: #333;
  color: #f3f4f6;
  flex-shrink: 0;
  z-index: 100;
}

.app-header-left {
  display: flex;
  align-items: center;
  gap: 0.5rem;
  overflow: hidden;
}

.app-header-logo {
  width: 94px;
  height: 17px;
  padding: 8px;
  box-sizing: content-box;
  flex-shrink: 0;
}

.app-header-divider {
  width: 1px;
  height: 24px;
  background: rgba(255, 255, 255, 0.15);
  margin: 0 0.25rem;
  flex-shrink: 0;
}

.app-header-right {
  display: flex;
  align-items: center;
  gap: 16px;
  flex-shrink: 0;
}

.app-header-btn {
  background: none;
  border: none;
  cursor: pointer;
  padding: 0;
  display: flex;
  align-items: center;
  justify-content: center;
  width: 24px;
  height: 24px;
  border-radius: 50%;
  color: #fff;
  text-decoration: none;
  transition: background-color 0.15s cubic-bezier(0.4, 0, 0.2, 1);
}
.app-header-btn:hover {
  background-color: rgba(255, 255, 255, 0.08);
}

/* ─── User Avatar ─── */
.header-user-avatar {
  border: none;
  padding: 0;
  position: relative;
  display: flex;
  align-items: center;
  justify-content: center;
  flex-shrink: 0;
  box-sizing: border-box;
  width: 36px;
  height: 36px;
  border-radius: 50%;
  overflow: hidden;
  background-color: #66bb6a;
  color: #121212;
  font-family: stolzl, Arial, sans-serif;
  font-size: 20px;
  line-height: 20px;
  font-weight: 400;
  text-align: center;
  cursor: pointer;
  -webkit-user-select: none;
          user-select: none;
}

.header-user-menu {
  position: absolute;
  top: calc(100% + 8px);
  right: 0;
  min-width: 200px;
  background: #2a2a2e;
  border: 1px solid #3e3e42;
  border-radius: 8px;
  padding: 4px;
  box-shadow: 0 8px 24px rgba(0, 0, 0, 0.4);
  z-index: 200;
}

.header-user-menu-info {
  display: flex;
  flex-direction: column;
  padding: 8px 12px;
  border-bottom: 1px solid #3e3e42;
  margin-bottom: 4px;
}

.header-user-menu-name {
  font-size: 0.8125rem;
  font-weight: 500;
  color: #fff;
}

.header-user-menu-email {
  font-size: 0.75rem;
  color: #9ca3af;
}

.header-user-menu-item {
  display: flex;
  align-items: center;
  gap: 8px;
  width: 100%;
  padding: 8px 12px;
  background: none;
  border: none;
  border-radius: 6px;
  color: #e5e7eb;
  font-size: 0.8125rem;
  cursor: pointer;
  transition: background 0.15s;
}

.header-user-menu-item:hover {
  background: rgba(255, 255, 255, 0.08);
}

/* ─── App Switcher ─── */
.header-app-switcher-menu {
  position: absolute;
  top: calc(100% + 20px);
  right: 0;
  min-width: 268px;
  background: rgb(46,	46,	46);
  border-radius: 4px;
  box-shadow: 0 8px 24px rgba(0, 0, 0, 0.4);
  z-index: 200;
  font-family: stolzl, Arial, sans-serif;
  font-weight: 400;
}

.header-app-switcher-item {
  display: flex;
  align-items: center;
  gap: 8px;
  width: 100%;
  background: none;
  border: none;
  text-decoration: none;
  cursor: pointer;
  transition: background 0.15s;
  padding: 10px 16px;
  height: 48px;
  color: #ffffff;
  font-size: 1rem;
}

.header-app-switcher-item:hover {
  background: rgba(255, 255, 255, 0.08);
}

.header-app-switcher-active {
  color: #8b5cf6;
}

.header-app-switcher-icon {
  width: 20px;
  height: 20px;
  display: inline-flex;
  align-items: center;
  justify-content: center;
  flex-shrink: 0;
}

.header-app-switcher-icon svg {
  display: block;
  max-width: 100%;
  max-height: 100%;
}

/* Header selector group */
.app-header-selector {
  display: flex;
  align-items: center;
  gap: 0.375rem;
}

.app-header-selector label {
  font-family: stolzl, Arial, sans-serif;
  font-weight: 500;
  color: rgba(255, 255, 255, 0.5);
  font-size: 0.6875rem;
  text-transform: uppercase;
  letter-spacing: 0.06em;
  white-space: nowrap;
}

.app-header-selector select {
  font-family: stolzl, Arial, sans-serif;
  font-size: 0.8125rem;
  font-weight: 400;
  color: #fff;
  background: transparent;
  border: 1px solid rgba(255, 255, 255, 0.12);
  border-radius: 6px;
  padding: 0.25rem 1.75rem 0.25rem 0.5rem;
  outline: none;
  cursor: pointer;
  appearance: none;
  background-image: url(${___CSS_LOADER_URL_REPLACEMENT_0___});
  background-repeat: no-repeat;
  background-position: right 0.5rem center;
  transition: border-color 0.2s;
}

.app-header-selector select:hover {
  border-color: rgba(255, 255, 255, 0.3);
}

.app-header-selector select:focus {
  border-color: rgba(255, 255, 255, 0.4);
}

.app-header-selector select option {
  background: #333;
  color: #fff;
}

/* ─── Account and workspace navigation ─── */
.context-navigation {
  position: relative;
  padding-bottom: 1rem;
  margin-bottom: 1rem;
  border-bottom: 1px solid var(--aw-border-soft);
}

.context-nav-label {
  display: block;
  margin-bottom: 0.375rem;
  color: var(--aw-text-muted);
  font-size: 0.6875rem;
  font-weight: 600;
  letter-spacing: 0.06em;
  text-transform: uppercase;
}

.account-switcher {
  position: relative;
  margin-bottom: 1rem;
}

.account-switcher-trigger,
.context-nav-option,
.workspace-list-item {
  width: 100%;
  border: 0;
  color: var(--aw-text-secondary);
  font: inherit;
  cursor: pointer;
  text-align: left;
}

.account-switcher-trigger {
  display: flex;
  align-items: center;
  justify-content: space-between;
  gap: 0.5rem;
  min-height: 38px;
  padding: 0.5rem 0.625rem;
  border: 1px solid var(--aw-border);
  border-radius: 6px;
  background: var(--aw-bg-elevated);
}

.account-switcher-trigger span {
  overflow: hidden;
  text-overflow: ellipsis;
  white-space: nowrap;
}

.account-switcher-trigger:hover,
.account-switcher-trigger:focus-visible {
  border-color: var(--aw-accent);
  outline: none;
}

.account-switcher-menu {
  position: absolute;
  top: calc(100% + 0.375rem);
  left: 0;
  right: 0;
  z-index: 210;
  padding: 0.375rem;
  border: 1px solid var(--aw-border);
  border-radius: 8px;
  background: #202024;
  box-shadow: var(--aw-shadow-strong);
}

.account-switcher-options {
  max-height: 220px;
  overflow-y: auto;
}

.context-search {
  display: flex;
  align-items: center;
  gap: 0.5rem;
  min-height: 36px;
  padding: 0 0.625rem;
  margin-bottom: 0.5rem;
  border: 1px solid var(--aw-border);
  border-radius: 6px;
  background: var(--aw-bg);
  color: var(--aw-text-muted);
}

.context-search:focus-within {
  border-color: var(--aw-accent);
}

.context-search input {
  width: 100%;
  border: 0;
  outline: 0;
  background: transparent;
  color: var(--aw-text);
  font: inherit;
  font-size: 0.8125rem;
}

.context-search input::placeholder {
  color: var(--aw-text-dim);
}

.context-nav-option,
.workspace-list-item {
  padding: 0.5rem 0.625rem;
  border-radius: 6px;
  background: transparent;
  font-size: 0.8125rem;
  overflow: hidden;
  text-overflow: ellipsis;
  white-space: nowrap;
}

.context-nav-option:hover,
.workspace-list-item:hover {
  background: rgba(255, 255, 255, 0.05);
}

.context-nav-option.active,
.workspace-list-item.active {
  background: rgba(163, 112, 245, 0.12);
  color: var(--aw-accent-metric);
}

.workspace-list {
  max-height: 240px;
  overflow-y: auto;
}

.context-nav-status,
.context-nav-empty {
  padding: 0.625rem;
  color: var(--aw-text-dim);
  font-size: 0.75rem;
}

.context-nav-error {
  color: #ef4444;
}

.chat-context-header {
  display: flex;
  align-items: center;
  justify-content: space-between;
  gap: 1rem;
  min-height: 64px;
  padding: 0.625rem 1.25rem;
  border-bottom: 1px solid var(--aw-border-soft);
  background: var(--aw-bg-elevated);
  flex-shrink: 0;
}

.chat-context-title {
  min-width: 0;
}

.chat-context-title span {
  display: block;
  color: var(--aw-text-muted);
  font-size: 0.6875rem;
  line-height: 1rem;
}

.chat-context-title h1 {
  margin: 0;
  color: var(--aw-text);
  font-size: 1rem;
  line-height: 1.5rem;
  overflow: hidden;
  text-overflow: ellipsis;
  white-space: nowrap;
}

.chat-context-header .app-header-selector {
  flex-shrink: 0;
}

.chat-agent-controls {
  display: flex;
  align-items: center;
  gap: 0.5rem;
  flex-shrink: 0;
}

.agent-details-trigger {
  position: relative;
  display: inline-flex;
  align-items: center;
  gap: 0.375rem;
  min-height: 32px;
  padding: 0.25rem 0.625rem;
  color: var(--aw-text);
  background: transparent;
  border: 1px solid rgba(255, 255, 255, 0.12);
  border-radius: 6px;
  font-family: stolzl, Arial, sans-serif;
  font-size: 0.75rem;
  cursor: pointer;
}

.agent-details-trigger:hover {
  background: rgba(255, 255, 255, 0.06);
  border-color: rgba(255, 255, 255, 0.3);
}

.agent-details-trigger:focus-visible,
.agent-details-close:focus-visible {
  outline: 2px solid #a370f5;
  outline-offset: 2px;
}

.agent-details-warning {
  display: inline-flex;
  align-items: center;
  justify-content: center;
  color: #fbbf24;
}

.agent-details-backdrop {
  position: fixed;
  inset: 0;
  z-index: 500;
  display: flex;
  align-items: center;
  justify-content: center;
  padding: 1rem;
  background: rgba(0, 0, 0, 0.72);
}

.agent-details-dialog {
  display: flex;
  flex-direction: column;
  width: min(560px, 100%);
  max-height: min(760px, calc(100vh - 2rem));
  overflow: hidden;
  color: var(--aw-text);
  background: var(--aw-bg);
  border: 1px solid var(--aw-border);
  border-radius: 10px;
  box-shadow: 0 24px 64px rgba(0, 0, 0, 0.55);
}

.agent-details-dialog-header {
  display: flex;
  align-items: flex-start;
  justify-content: space-between;
  gap: 1rem;
  padding: 1rem 1.25rem;
  border-bottom: 1px solid var(--aw-border-soft);
}

.agent-details-dialog-header h2,
.agent-details-dialog-header p {
  margin: 0;
}

.agent-details-dialog-header h2 {
  font-size: 1rem;
  font-weight: 600;
}

.agent-details-dialog-header p {
  margin-top: 0.125rem;
  color: var(--aw-text-muted);
  font-size: 0.75rem;
}

.agent-details-close {
  display: inline-flex;
  align-items: center;
  justify-content: center;
  width: 32px;
  height: 32px;
  flex-shrink: 0;
  color: var(--aw-text-muted);
  background: transparent;
  border: none;
  border-radius: 6px;
  cursor: pointer;
}

.agent-details-close:hover {
  color: var(--aw-text);
  background: rgba(255, 255, 255, 0.08);
}

.agent-details-dialog-body {
  overflow-y: auto;
  padding: 0.75rem 1.25rem 1.25rem;
}

.agent-details-error {
  display: flex;
  align-items: flex-start;
  gap: 0.5rem;
  margin-top: 0.5rem;
  padding: 0.75rem;
  color: #ef4444;
  background: rgba(239, 68, 68, 0.1);
  border: 1px solid rgba(239, 68, 68, 0.2);
  border-radius: 8px;
  font-size: 0.75rem;
}

.agent-details-error strong {
  display: block;
  margin-bottom: 0.125rem;
}

/* ─── Artstash Buttons ─── */
.aw-btn-primary {
  display: inline-flex;
  align-items: center;
  justify-content: center;
  font-family: stolzl, Arial, sans-serif;
  font-size: 14px;
  font-weight: 400;
  line-height: 24px;
  color: #fff;
  background-color: #A370F5;
  border: none;
  border-radius: 4px;
  padding: 6px 16px;
  min-width: 64px;
  cursor: pointer;
  -webkit-user-select: none;
          user-select: none;
  text-transform: none;
  text-decoration: none;
  box-shadow: rgba(0,0,0,0.2) 0 3px 1px -2px, rgba(0,0,0,0.14) 0 2px 2px 0, rgba(0,0,0,0.12) 0 1px 5px 0;
  transition: background-color 250ms cubic-bezier(0.4,0,0.2,1), box-shadow 250ms cubic-bezier(0.4,0,0.2,1);
}
.aw-btn-primary:hover {
  background-color: #9260e0;
}
.aw-btn-primary:disabled {
  opacity: 0.5;
  cursor: not-allowed;
}

.aw-btn-secondary {
  display: inline-flex;
  align-items: center;
  justify-content: center;
  font-family: stolzl, Arial, sans-serif;
  font-size: 14px;
  font-weight: 400;
  line-height: 24px;
  color: #fff;
  background-color: transparent;
  border: 1px solid rgba(163, 112, 245, 0.5);
  border-radius: 4px;
  padding: 5px 15px;
  min-width: 64px;
  cursor: pointer;
  -webkit-user-select: none;
          user-select: none;
  text-transform: none;
  text-decoration: none;
  transition: background-color 250ms cubic-bezier(0.4,0,0.2,1), border-color 250ms cubic-bezier(0.4,0,0.2,1);
}
.aw-btn-secondary:hover {
  background-color: rgba(163, 112, 245, 0.08);
  border-color: rgba(163, 112, 245, 0.7);
}
.aw-btn-secondary:disabled {
  opacity: 0.5;
  cursor: not-allowed;
}

/* Small variant for sidebar / compact areas */
.aw-btn-primary.aw-btn-sm,
.aw-btn-secondary.aw-btn-sm {
  font-size: 0.75rem;
  padding: 4px 12px;
  min-width: unset;
  line-height: 1.5;
}

/* ─── Session List (workspace-style) ─── */
.session-list-header {
  display: flex;
  justify-content: space-between;
  align-items: center;
  padding: 0 0.25rem;
  margin-bottom: 0.25rem;
}

.session-list-header h4 {
  margin: 0;
  font-family: stolzl, Arial, sans-serif;
  font-size: 0.75rem;
  font-weight: 500;
  color: #6b7280;
  text-transform: uppercase;
  letter-spacing: 0.04em;
}

.session-list-items {
  list-style: none;
  padding: 0;
  margin: 0;
}

.session-list-item {
  display: flex;
  align-items: center;
  width: 100%;
  padding: 8px 12px;
  font-family: stolzl, Arial, sans-serif;
  font-size: 0.8125rem;
  font-weight: 400;
  line-height: 1.5;
  color: #d1d1d6;
  background: transparent;
  border: none;
  border-radius: 4px;
  cursor: pointer;
  text-align: left;
  white-space: nowrap;
  overflow: hidden;
  text-overflow: ellipsis;
  transition: background-color 250ms cubic-bezier(0.4,0,0.2,1);
}

.session-list-item:hover {
  background-color: rgba(255, 255, 255, 0.04);
}

.session-list-item.active {
  background-color: rgba(163, 112, 245, 0.12);
  color: #A370F5;
}

code {
  font-family: source-code-pro, Menlo, Monaco, Consolas, 'Courier New',
    monospace;
}

/* Fix chat layout and code display */
.chat-area {
  max-width: 100vw;
  overflow-x: hidden;
}

.messages-list {
  width: 100%;
  box-sizing: border-box;
}

/* Markdown Code Blocks */
pre {
  background-color: #0d0d0d;
  color: #d4d4d4;
  padding: 1rem;
  border-radius: var(--aw-radius-sm);
  border: 1px solid var(--aw-border-soft);
  overflow-x: auto;
  margin: 0.5rem 0;
  max-width: 100%;
}

pre code {
  background-color: transparent;
  padding: 0;
  border-radius: 0;
  color: inherit;
}

/* Inline code */
p code {
  background-color: var(--aw-accent-tag-bg);
  padding: 0.2rem 0.4rem;
  border-radius: 4px;
  font-size: 0.875em;
  color: var(--aw-accent-alt);
}

/* Ensure message bubbles don't overflow */
.message-bubble {
  max-width: 100%;
  overflow-wrap: break-word;
}
.message-bubble img {
  max-width: 100%;
  height: auto;
}

/* Markdown links */
.message-bubble a {
  color: var(--aw-accent-metric);
  text-decoration: underline;
  text-decoration-color: rgba(167, 139, 250, 0.4);
}
.message-bubble a:hover {
  color: var(--aw-accent-alt);
}

/* Large Asset Grid */
.assets-grid {
  display: grid;
  grid-template-columns: repeat(auto-fill, minmax(300px, 1fr));
  gap: 1rem;
  margin-top: 0.5rem;
  max-height: 600px;
  overflow-y: auto;
  padding-right: 0.25rem;
}

.asset-card {
  display: flex;
  flex-direction: column;
  background: var(--aw-bg-elevated);
  border: 1px solid var(--aw-border);
  border-radius: var(--aw-radius-md);
  padding: 0;
  gap: 0;
  align-items: stretch;
  transition: box-shadow 0.2s, border-color 0.2s;
  overflow: hidden;
}

.asset-card:hover {
  box-shadow: var(--aw-shadow-medium);
  border-color: var(--aw-accent-border);
}

.asset-card .thumbnail {
  width: 100%;
  height: 200px;
  flex-shrink: 0;
  background: #0d0d0d;
  display: flex;
  align-items: center;
  justify-content: center;
  overflow: hidden;
  color: var(--aw-text-muted);
  position: relative;
}

.asset-card .thumbnail img {
  width: 100%;
  height: 100%;
  object-fit: cover;
}

.asset-card .details {
  padding: 1rem;
  flex: 1 1;
  min-width: 0;
  display: flex;
  flex-direction: column;
  gap: 0.5rem;
}

.asset-card .details h4 {
  margin: 0;
  font-size: 0.9rem;
  white-space: nowrap;
  overflow: hidden;
  text-overflow: ellipsis;
  font-weight: 600;
  color: var(--aw-text);
}

.asset-card .details .tags {
  display: flex;
  gap: 0.25rem;
  flex-wrap: wrap;
}

.asset-card .details .tags span {
  display: inline-flex;
  align-items: center;
  height: 22px;
  padding: 0 0.5rem;
  border: 1px solid #464646;
  border-radius: 11px;
  font-family: stolzl, Arial, sans-serif;
  font-size: 0.6875rem;
  font-weight: 400;
  color: #fff;
  background: transparent;
  white-space: nowrap;
}

.asset-card button {
  align-self: flex-start;
  background: var(--aw-accent);
  color: white;
  border: none;
  padding: 0.2rem 0.5rem;
  border-radius: 4px;
  font-size: 0.75rem;
  cursor: pointer;
  transition: background 0.2s;
}

.asset-card button:hover {
  background: var(--aw-accent-alt);
}

.asset-card .thumbnail-loading,
.asset-card .thumbnail-error {
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  gap: 0.5rem;
  color: var(--aw-text-muted);
  font-size: 0.75rem;
}

.asset-card .thumbnail-error {
  color: #ef4444;
}

.asset-card .video-badge {
  position: absolute;
  top: 8px;
  right: 8px;
  background: rgba(0, 0, 0, 0.7);
  border-radius: 4px;
  padding: 4px;
  color: white;
  display: flex;
  align-items: center;
}

.asset-card .media-type-badge {
  display: inline-block;
  font-size: 0.65rem;
  text-transform: uppercase;
  letter-spacing: 0.5px;
  color: var(--aw-text-muted);
  background: var(--aw-bg-hover);
  padding: 0.1rem 0.4rem;
  border-radius: 3px;
  width: fit-content;
}

.asset-card .asset-icon {
  opacity: 0.5;
}

/* Inline asset images in chat messages */
.inline-asset {
  display: block;
  margin: 0.75rem 0;
}

/* Strip list bullets when items contain inline asset cards */
.message-bubble li:has(.inline-asset) {
  list-style: none;
}
.message-bubble ul:has(.inline-asset),
.message-bubble ol:has(.inline-asset) {
  padding-left: 0;
}

.inline-asset-link {
  text-decoration: none;
  color: inherit;
  display: block;
  border-radius: 8px;
  overflow: hidden;
  border: 1px solid var(--aw-border, #2e2e2e);
  transition: border-color 0.2s, box-shadow 0.2s;
  background: #0d0d0d;
  max-width: 480px;
}

.inline-asset-link:hover {
  border-color: var(--aw-accent-border, #8b5cf6);
  box-shadow: 0 2px 12px rgba(139, 92, 246, 0.15);
}

.inline-asset-image-wrapper {
  display: block;
  position: relative;
  max-height: 300px;
  max-width: 480px;
  overflow: hidden;
}

.inline-asset-image {
  display: block;
  width: 100%;
  max-height: 300px;
  object-fit: cover;
}

.inline-asset-video-badge {
  position: absolute;
  top: 50%;
  left: 50%;
  transform: translate(-50%, -50%);
  background: rgba(0, 0, 0, 0.6);
  border-radius: 50%;
  padding: 8px;
  color: white;
  display: flex;
  align-items: center;
  justify-content: center;
}

.inline-asset-placeholder {
  display: flex;
  align-items: center;
  justify-content: center;
  height: 120px;
  color: var(--aw-text-muted, #6b7280);
  opacity: 0.5;
}

.inline-asset-caption {
  display: flex;
  align-items: center;
  gap: 0.5rem;
  padding: 0.5rem 0.75rem;
  font-size: 0.8rem;
  color: var(--aw-text-muted, #9ca3af);
  border-top: 1px solid var(--aw-border, #2e2e2e);
}

.inline-asset-name {
  flex: 1 1;
  overflow: hidden;
  text-overflow: ellipsis;
  white-space: nowrap;
}

.inline-asset-tags {
  display: flex;
  gap: 0.25rem;
  flex-wrap: wrap;
  padding: 0.25rem 0.75rem 0.5rem;
}

.inline-asset-tags .tag {
  display: inline-flex;
  align-items: center;
  height: 22px;
  padding: 0 0.5rem;
  border: 1px solid #464646;
  border-radius: 11px;
  font-family: stolzl, Arial, sans-serif;
  font-size: 0.6875rem;
  font-weight: 400;
  color: #fff;
  background: transparent;
  white-space: nowrap;
  transition: background-color 0.3s cubic-bezier(0.4, 0, 0.2, 1);
}

/* Scrollbar styling */
::-webkit-scrollbar {
  width: 6px;
}
::-webkit-scrollbar-track {
  background: transparent;
}
::-webkit-scrollbar-thumb {
  background: var(--aw-border);
  border-radius: 3px;
}
::-webkit-scrollbar-thumb:hover {
  background: #444;
}

/* Select / dropdown dark styling */
select, input[type="text"], textarea {
  color-scheme: dark;
}

/* Thinking Indicator */
.thinking-indicator {
  display: inline-flex;
  align-items: center;
  gap: 0.5rem;
  background: #1a1a1e !important;
  border: 1px solid #2e2e2e !important;
  padding: 0.6rem 1rem !important;
  border-radius: 12px;
  animation: thinking-fade-in 0.2s ease-out;
}

.thinking-label {
  font-size: 0.875rem;
  color: #9ca3af;
}

.thinking-dots {
  display: inline-flex;
  gap: 3px;
  align-items: center;
}

.thinking-dots .dot {
  width: 5px;
  height: 5px;
  border-radius: 50%;
  background: #8b5cf6;
  animation: thinking-bounce 1.4s infinite ease-in-out both;
}

.thinking-dots .dot:nth-child(1) { animation-delay: 0s; }
.thinking-dots .dot:nth-child(2) { animation-delay: 0.16s; }
.thinking-dots .dot:nth-child(3) { animation-delay: 0.32s; }

@keyframes thinking-bounce {
  0%, 80%, 100% { transform: scale(0.6); opacity: 0.4; }
  40% { transform: scale(1); opacity: 1; }
}

@keyframes thinking-fade-in {
  from { opacity: 0; transform: translateY(4px); }
  to { opacity: 1; transform: translateY(0); }
}

/* === Video Scrub Preview === */
.video-scrub-container {
  position: relative;
  width: 100%;
  height: 100%;
  cursor: pointer;
  overflow: hidden;
}

.video-scrub-image,
.video-scrub-video {
  width: 100%;
  height: 100%;
  object-fit: cover;
  display: block;
}

.video-scrub-placeholder {
  width: 100%;
  height: 100%;
  display: flex;
  align-items: center;
  justify-content: center;
  background: var(--aw-bg-elevated, #1a1a1e);
  color: var(--aw-text-secondary, #d1d1d6);
  font-size: 2rem;
}

.video-scrub-badge {
  position: absolute;
  bottom: 6px;
  right: 6px;
  background: rgba(0, 0, 0, 0.6);
  color: white;
  font-size: 10px;
  padding: 2px 6px;
  border-radius: 4px;
  pointer-events: none;
  z-index: 2;
  transition: opacity 0.15s ease;
}

.video-scrub-container:hover .video-scrub-badge {
  opacity: 0;
}
`, "",{"version":3,"sources":["webpack://./src/index.css"],"names":[],"mappings":"AAAA,0CAA0C;AAC1C;EACE,gBAAgB;EAChB,wBAAwB;EACxB,yBAAyB;EACzB,mCAAmC;EACnC,oBAAoB;EACpB,yBAAyB;EACzB,kBAAkB;EAClB,4BAA4B;EAC5B,wBAAwB;EACxB,mBAAmB;EACnB,oBAAoB;EACpB,wBAAwB;EACxB,2BAA2B;EAC3B,wCAAwC;EACxC,2CAA2C;EAC3C,4CAA4C;EAC5C,gBAAgB;EAChB,gBAAgB;EAChB,mBAAmB;EACnB,oBAAoB;EACpB,oBAAoB;EACpB,8CAA8C;EAC9C,8CAA8C;EAC9C,+CAA+C;AACjD;;AAEA,uBAAuB;AACvB;EACE,OAAO,uBAAuB,EAAE;EAChC,KAAK,yBAAyB,EAAE;AAClC;;AAEA,UAAU;AACV;EACE,sBAAsB;AACxB;;AAEA;EACE,SAAS;EACT,UAAU;EACV,YAAY;EACZ,gBAAgB;AAClB;;AAEA;EACE,SAAS;EACT,+JAA+J;EAC/J,mCAAmC;EACnC,kCAAkC;EAClC,wBAAwB;EACxB,qBAAqB;AACvB;;AAEA,wCAAwC;AACxC;EACE,aAAa;EACb,mBAAmB;EACnB,8BAA8B;EAC9B,YAAY;EACZ,iBAAiB;EACjB,sBAAsB;EACtB,cAAc;EACd,cAAc;EACd,YAAY;AACd;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,WAAW;EACX,gBAAgB;AAClB;;AAEA;EACE,WAAW;EACX,YAAY;EACZ,YAAY;EACZ,uBAAuB;EACvB,cAAc;AAChB;;AAEA;EACE,UAAU;EACV,YAAY;EACZ,qCAAqC;EACrC,iBAAiB;EACjB,cAAc;AAChB;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,SAAS;EACT,cAAc;AAChB;;AAEA;EACE,gBAAgB;EAChB,YAAY;EACZ,eAAe;EACf,UAAU;EACV,aAAa;EACb,mBAAmB;EACnB,uBAAuB;EACvB,WAAW;EACX,YAAY;EACZ,kBAAkB;EAClB,WAAW;EACX,qBAAqB;EACrB,+DAA+D;AACjE;AACA;EACE,2CAA2C;AAC7C;;AAEA,wBAAwB;AACxB;EACE,YAAY;EACZ,UAAU;EACV,kBAAkB;EAClB,aAAa;EACb,mBAAmB;EACnB,uBAAuB;EACvB,cAAc;EACd,sBAAsB;EACtB,WAAW;EACX,YAAY;EACZ,kBAAkB;EAClB,gBAAgB;EAChB,yBAAyB;EACzB,cAAc;EACd,sCAAsC;EACtC,eAAe;EACf,iBAAiB;EACjB,gBAAgB;EAChB,kBAAkB;EAClB,eAAe;EACf,yBAAiB;UAAjB,iBAAiB;AACnB;;AAEA;EACE,kBAAkB;EAClB,qBAAqB;EACrB,QAAQ;EACR,gBAAgB;EAChB,mBAAmB;EACnB,yBAAyB;EACzB,kBAAkB;EAClB,YAAY;EACZ,yCAAyC;EACzC,YAAY;AACd;;AAEA;EACE,aAAa;EACb,sBAAsB;EACtB,iBAAiB;EACjB,gCAAgC;EAChC,kBAAkB;AACpB;;AAEA;EACE,oBAAoB;EACpB,gBAAgB;EAChB,WAAW;AACb;;AAEA;EACE,kBAAkB;EAClB,cAAc;AAChB;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,QAAQ;EACR,WAAW;EACX,iBAAiB;EACjB,gBAAgB;EAChB,YAAY;EACZ,kBAAkB;EAClB,cAAc;EACd,oBAAoB;EACpB,eAAe;EACf,4BAA4B;AAC9B;;AAEA;EACE,qCAAqC;AACvC;;AAEA,yBAAyB;AACzB;EACE,kBAAkB;EAClB,sBAAsB;EACtB,QAAQ;EACR,gBAAgB;EAChB,2BAA2B;EAC3B,kBAAkB;EAClB,yCAAyC;EACzC,YAAY;EACZ,sCAAsC;EACtC,gBAAgB;AAClB;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,QAAQ;EACR,WAAW;EACX,gBAAgB;EAChB,YAAY;EACZ,qBAAqB;EACrB,eAAe;EACf,4BAA4B;EAC5B,kBAAkB;EAClB,YAAY;EACZ,cAAc;EACd,eAAe;AACjB;;AAEA;EACE,qCAAqC;AACvC;;AAEA;EACE,cAAc;AAChB;;AAEA;EACE,WAAW;EACX,YAAY;EACZ,oBAAoB;EACpB,mBAAmB;EACnB,uBAAuB;EACvB,cAAc;AAChB;;AAEA;EACE,cAAc;EACd,eAAe;EACf,gBAAgB;AAClB;;AAEA,0BAA0B;AAC1B;EACE,aAAa;EACb,mBAAmB;EACnB,aAAa;AACf;;AAEA;EACE,sCAAsC;EACtC,gBAAgB;EAChB,+BAA+B;EAC/B,oBAAoB;EACpB,yBAAyB;EACzB,sBAAsB;EACtB,mBAAmB;AACrB;;AAEA;EACE,sCAAsC;EACtC,oBAAoB;EACpB,gBAAgB;EAChB,WAAW;EACX,uBAAuB;EACvB,2CAA2C;EAC3C,kBAAkB;EAClB,uCAAuC;EACvC,aAAa;EACb,eAAe;EAGf,gBAAgB;EAChB,yDAAqQ;EACrQ,4BAA4B;EAC5B,wCAAwC;EACxC,6BAA6B;AAC/B;;AAEA;EACE,sCAAsC;AACxC;;AAEA;EACE,sCAAsC;AACxC;;AAEA;EACE,gBAAgB;EAChB,WAAW;AACb;;AAEA,6CAA6C;AAC7C;EACE,kBAAkB;EAClB,oBAAoB;EACpB,mBAAmB;EACnB,8CAA8C;AAChD;;AAEA;EACE,cAAc;EACd,uBAAuB;EACvB,2BAA2B;EAC3B,oBAAoB;EACpB,gBAAgB;EAChB,sBAAsB;EACtB,yBAAyB;AAC3B;;AAEA;EACE,kBAAkB;EAClB,mBAAmB;AACrB;;AAEA;;;EAGE,WAAW;EACX,SAAS;EACT,+BAA+B;EAC/B,aAAa;EACb,eAAe;EACf,gBAAgB;AAClB;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,8BAA8B;EAC9B,WAAW;EACX,gBAAgB;EAChB,wBAAwB;EACxB,kCAAkC;EAClC,kBAAkB;EAClB,iCAAiC;AACnC;;AAEA;EACE,gBAAgB;EAChB,uBAAuB;EACvB,mBAAmB;AACrB;;AAEA;;EAEE,8BAA8B;EAC9B,aAAa;AACf;;AAEA;EACE,kBAAkB;EAClB,0BAA0B;EAC1B,OAAO;EACP,QAAQ;EACR,YAAY;EACZ,iBAAiB;EACjB,kCAAkC;EAClC,kBAAkB;EAClB,mBAAmB;EACnB,mCAAmC;AACrC;;AAEA;EACE,iBAAiB;EACjB,gBAAgB;AAClB;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,WAAW;EACX,gBAAgB;EAChB,mBAAmB;EACnB,qBAAqB;EACrB,kCAAkC;EAClC,kBAAkB;EAClB,wBAAwB;EACxB,2BAA2B;AAC7B;;AAEA;EACE,8BAA8B;AAChC;;AAEA;EACE,WAAW;EACX,SAAS;EACT,UAAU;EACV,uBAAuB;EACvB,qBAAqB;EACrB,aAAa;EACb,oBAAoB;AACtB;;AAEA;EACE,yBAAyB;AAC3B;;AAEA;;EAEE,wBAAwB;EACxB,kBAAkB;EAClB,uBAAuB;EACvB,oBAAoB;EACpB,gBAAgB;EAChB,uBAAuB;EACvB,mBAAmB;AACrB;;AAEA;;EAEE,qCAAqC;AACvC;;AAEA;;EAEE,qCAAqC;EACrC,8BAA8B;AAChC;;AAEA;EACE,iBAAiB;EACjB,gBAAgB;AAClB;;AAEA;;EAEE,iBAAiB;EACjB,yBAAyB;EACzB,kBAAkB;AACpB;;AAEA;EACE,cAAc;AAChB;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,8BAA8B;EAC9B,SAAS;EACT,gBAAgB;EAChB,yBAAyB;EACzB,8CAA8C;EAC9C,iCAAiC;EACjC,cAAc;AAChB;;AAEA;EACE,YAAY;AACd;;AAEA;EACE,cAAc;EACd,2BAA2B;EAC3B,oBAAoB;EACpB,iBAAiB;AACnB;;AAEA;EACE,SAAS;EACT,qBAAqB;EACrB,eAAe;EACf,mBAAmB;EACnB,gBAAgB;EAChB,uBAAuB;EACvB,mBAAmB;AACrB;;AAEA;EACE,cAAc;AAChB;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,WAAW;EACX,cAAc;AAChB;;AAEA;EACE,kBAAkB;EAClB,oBAAoB;EACpB,mBAAmB;EACnB,aAAa;EACb,gBAAgB;EAChB,yBAAyB;EACzB,qBAAqB;EACrB,uBAAuB;EACvB,2CAA2C;EAC3C,kBAAkB;EAClB,sCAAsC;EACtC,kBAAkB;EAClB,eAAe;AACjB;;AAEA;EACE,qCAAqC;EACrC,sCAAsC;AACxC;;AAEA;;EAEE,0BAA0B;EAC1B,mBAAmB;AACrB;;AAEA;EACE,oBAAoB;EACpB,mBAAmB;EACnB,uBAAuB;EACvB,cAAc;AAChB;;AAEA;EACE,eAAe;EACf,QAAQ;EACR,YAAY;EACZ,aAAa;EACb,mBAAmB;EACnB,uBAAuB;EACvB,aAAa;EACb,+BAA+B;AACjC;;AAEA;EACE,aAAa;EACb,sBAAsB;EACtB,uBAAuB;EACvB,0CAA0C;EAC1C,gBAAgB;EAChB,qBAAqB;EACrB,wBAAwB;EACxB,kCAAkC;EAClC,mBAAmB;EACnB,2CAA2C;AAC7C;;AAEA;EACE,aAAa;EACb,uBAAuB;EACvB,8BAA8B;EAC9B,SAAS;EACT,qBAAqB;EACrB,8CAA8C;AAChD;;AAEA;;EAEE,SAAS;AACX;;AAEA;EACE,eAAe;EACf,gBAAgB;AAClB;;AAEA;EACE,oBAAoB;EACpB,2BAA2B;EAC3B,kBAAkB;AACpB;;AAEA;EACE,oBAAoB;EACpB,mBAAmB;EACnB,uBAAuB;EACvB,WAAW;EACX,YAAY;EACZ,cAAc;EACd,2BAA2B;EAC3B,uBAAuB;EACvB,YAAY;EACZ,kBAAkB;EAClB,eAAe;AACjB;;AAEA;EACE,qBAAqB;EACrB,qCAAqC;AACvC;;AAEA;EACE,gBAAgB;EAChB,gCAAgC;AAClC;;AAEA;EACE,aAAa;EACb,uBAAuB;EACvB,WAAW;EACX,kBAAkB;EAClB,gBAAgB;EAChB,cAAc;EACd,kCAAkC;EAClC,wCAAwC;EACxC,kBAAkB;EAClB,kBAAkB;AACpB;;AAEA;EACE,cAAc;EACd,uBAAuB;AACzB;;AAEA,6BAA6B;AAC7B;EACE,oBAAoB;EACpB,mBAAmB;EACnB,uBAAuB;EACvB,sCAAsC;EACtC,eAAe;EACf,gBAAgB;EAChB,iBAAiB;EACjB,WAAW;EACX,yBAAyB;EACzB,YAAY;EACZ,kBAAkB;EAClB,iBAAiB;EACjB,eAAe;EACf,eAAe;EACf,yBAAiB;UAAjB,iBAAiB;EACjB,oBAAoB;EACpB,qBAAqB;EACrB,sGAAsG;EACtG,wGAAwG;AAC1G;AACA;EACE,yBAAyB;AAC3B;AACA;EACE,YAAY;EACZ,mBAAmB;AACrB;;AAEA;EACE,oBAAoB;EACpB,mBAAmB;EACnB,uBAAuB;EACvB,sCAAsC;EACtC,eAAe;EACf,gBAAgB;EAChB,iBAAiB;EACjB,WAAW;EACX,6BAA6B;EAC7B,0CAA0C;EAC1C,kBAAkB;EAClB,iBAAiB;EACjB,eAAe;EACf,eAAe;EACf,yBAAiB;UAAjB,iBAAiB;EACjB,oBAAoB;EACpB,qBAAqB;EACrB,0GAA0G;AAC5G;AACA;EACE,2CAA2C;EAC3C,sCAAsC;AACxC;AACA;EACE,YAAY;EACZ,mBAAmB;AACrB;;AAEA,8CAA8C;AAC9C;;EAEE,kBAAkB;EAClB,iBAAiB;EACjB,gBAAgB;EAChB,gBAAgB;AAClB;;AAEA,2CAA2C;AAC3C;EACE,aAAa;EACb,8BAA8B;EAC9B,mBAAmB;EACnB,kBAAkB;EAClB,sBAAsB;AACxB;;AAEA;EACE,SAAS;EACT,sCAAsC;EACtC,kBAAkB;EAClB,gBAAgB;EAChB,cAAc;EACd,yBAAyB;EACzB,sBAAsB;AACxB;;AAEA;EACE,gBAAgB;EAChB,UAAU;EACV,SAAS;AACX;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,WAAW;EACX,iBAAiB;EACjB,sCAAsC;EACtC,oBAAoB;EACpB,gBAAgB;EAChB,gBAAgB;EAChB,cAAc;EACd,uBAAuB;EACvB,YAAY;EACZ,kBAAkB;EAClB,eAAe;EACf,gBAAgB;EAChB,mBAAmB;EACnB,gBAAgB;EAChB,uBAAuB;EACvB,4DAA4D;AAC9D;;AAEA;EACE,2CAA2C;AAC7C;;AAEA;EACE,2CAA2C;EAC3C,cAAc;AAChB;;AAEA;EACE;aACW;AACb;;AAEA,qCAAqC;AACrC;EACE,gBAAgB;EAChB,kBAAkB;AACpB;;AAEA;EACE,WAAW;EACX,sBAAsB;AACxB;;AAEA,yBAAyB;AACzB;EACE,yBAAyB;EACzB,cAAc;EACd,aAAa;EACb,kCAAkC;EAClC,uCAAuC;EACvC,gBAAgB;EAChB,gBAAgB;EAChB,eAAe;AACjB;;AAEA;EACE,6BAA6B;EAC7B,UAAU;EACV,gBAAgB;EAChB,cAAc;AAChB;;AAEA,gBAAgB;AAChB;EACE,yCAAyC;EACzC,sBAAsB;EACtB,kBAAkB;EAClB,kBAAkB;EAClB,2BAA2B;AAC7B;;AAEA,0CAA0C;AAC1C;EACE,eAAe;EACf,yBAAyB;AAC3B;AACA;EACE,eAAe;EACf,YAAY;AACd;;AAEA,mBAAmB;AACnB;EACE,8BAA8B;EAC9B,0BAA0B;EAC1B,+CAA+C;AACjD;AACA;EACE,2BAA2B;AAC7B;;AAEA,qBAAqB;AACrB;EACE,aAAa;EACb,4DAA4D;EAC5D,SAAS;EACT,kBAAkB;EAClB,iBAAiB;EACjB,gBAAgB;EAChB,sBAAsB;AACxB;;AAEA;EACE,aAAa;EACb,sBAAsB;EACtB,iCAAiC;EACjC,kCAAkC;EAClC,kCAAkC;EAClC,UAAU;EACV,MAAM;EACN,oBAAoB;EACpB,8CAA8C;EAC9C,gBAAgB;AAClB;;AAEA;EACE,mCAAmC;EACnC,qCAAqC;AACvC;;AAEA;EACE,WAAW;EACX,aAAa;EACb,cAAc;EACd,mBAAmB;EACnB,aAAa;EACb,mBAAmB;EACnB,uBAAuB;EACvB,gBAAgB;EAChB,2BAA2B;EAC3B,kBAAkB;AACpB;;AAEA;EACE,WAAW;EACX,YAAY;EACZ,iBAAiB;AACnB;;AAEA;EACE,aAAa;EACb,SAAO;EACP,YAAY;EACZ,aAAa;EACb,sBAAsB;EACtB,WAAW;AACb;;AAEA;EACE,SAAS;EACT,iBAAiB;EACjB,mBAAmB;EACnB,gBAAgB;EAChB,uBAAuB;EACvB,gBAAgB;EAChB,qBAAqB;AACvB;;AAEA;EACE,aAAa;EACb,YAAY;EACZ,eAAe;AACjB;;AAEA;EACE,oBAAoB;EACpB,mBAAmB;EACnB,YAAY;EACZ,iBAAiB;EACjB,yBAAyB;EACzB,mBAAmB;EACnB,sCAAsC;EACtC,oBAAoB;EACpB,gBAAgB;EAChB,WAAW;EACX,uBAAuB;EACvB,mBAAmB;AACrB;;AAEA;EACE,sBAAsB;EACtB,4BAA4B;EAC5B,YAAY;EACZ,YAAY;EACZ,sBAAsB;EACtB,kBAAkB;EAClB,kBAAkB;EAClB,eAAe;EACf,2BAA2B;AAC7B;;AAEA;EACE,gCAAgC;AAClC;;AAEA;;EAEE,aAAa;EACb,sBAAsB;EACtB,mBAAmB;EACnB,uBAAuB;EACvB,WAAW;EACX,2BAA2B;EAC3B,kBAAkB;AACpB;;AAEA;EACE,cAAc;AAChB;;AAEA;EACE,kBAAkB;EAClB,QAAQ;EACR,UAAU;EACV,8BAA8B;EAC9B,kBAAkB;EAClB,YAAY;EACZ,YAAY;EACZ,aAAa;EACb,mBAAmB;AACrB;;AAEA;EACE,qBAAqB;EACrB,kBAAkB;EAClB,yBAAyB;EACzB,qBAAqB;EACrB,2BAA2B;EAC3B,8BAA8B;EAC9B,sBAAsB;EACtB,kBAAkB;EAClB,kBAAkB;AACpB;;AAEA;EACE,YAAY;AACd;;AAEA,yCAAyC;AACzC;EACE,cAAc;EACd,iBAAiB;AACnB;;AAEA,6DAA6D;AAC7D;EACE,gBAAgB;AAClB;AACA;;EAEE,eAAe;AACjB;;AAEA;EACE,qBAAqB;EACrB,cAAc;EACd,cAAc;EACd,kBAAkB;EAClB,gBAAgB;EAChB,2CAA2C;EAC3C,8CAA8C;EAC9C,mBAAmB;EACnB,gBAAgB;AAClB;;AAEA;EACE,8CAA8C;EAC9C,+CAA+C;AACjD;;AAEA;EACE,cAAc;EACd,kBAAkB;EAClB,iBAAiB;EACjB,gBAAgB;EAChB,gBAAgB;AAClB;;AAEA;EACE,cAAc;EACd,WAAW;EACX,iBAAiB;EACjB,iBAAiB;AACnB;;AAEA;EACE,kBAAkB;EAClB,QAAQ;EACR,SAAS;EACT,gCAAgC;EAChC,8BAA8B;EAC9B,kBAAkB;EAClB,YAAY;EACZ,YAAY;EACZ,aAAa;EACb,mBAAmB;EACnB,uBAAuB;AACzB;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,uBAAuB;EACvB,aAAa;EACb,oCAAoC;EACpC,YAAY;AACd;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,WAAW;EACX,uBAAuB;EACvB,iBAAiB;EACjB,oCAAoC;EACpC,+CAA+C;AACjD;;AAEA;EACE,SAAO;EACP,gBAAgB;EAChB,uBAAuB;EACvB,mBAAmB;AACrB;;AAEA;EACE,aAAa;EACb,YAAY;EACZ,eAAe;EACf,+BAA+B;AACjC;;AAEA;EACE,oBAAoB;EACpB,mBAAmB;EACnB,YAAY;EACZ,iBAAiB;EACjB,yBAAyB;EACzB,mBAAmB;EACnB,sCAAsC;EACtC,oBAAoB;EACpB,gBAAgB;EAChB,WAAW;EACX,uBAAuB;EACvB,mBAAmB;EACnB,8DAA8D;AAChE;;AAEA,sBAAsB;AACtB;EACE,UAAU;AACZ;AACA;EACE,uBAAuB;AACzB;AACA;EACE,4BAA4B;EAC5B,kBAAkB;AACpB;AACA;EACE,gBAAgB;AAClB;;AAEA,mCAAmC;AACnC;EACE,kBAAkB;AACpB;;AAEA,uBAAuB;AACvB;EACE,oBAAoB;EACpB,mBAAmB;EACnB,WAAW;EACX,8BAA8B;EAC9B,oCAAoC;EACpC,+BAA+B;EAC/B,mBAAmB;EACnB,yCAAyC;AAC3C;;AAEA;EACE,mBAAmB;EACnB,cAAc;AAChB;;AAEA;EACE,oBAAoB;EACpB,QAAQ;EACR,mBAAmB;AACrB;;AAEA;EACE,UAAU;EACV,WAAW;EACX,kBAAkB;EAClB,mBAAmB;EACnB,yDAAyD;AAC3D;;AAEA,mCAAmC,mBAAmB,EAAE;AACxD,mCAAmC,sBAAsB,EAAE;AAC3D,mCAAmC,sBAAsB,EAAE;;AAE3D;EACE,gBAAgB,qBAAqB,EAAE,YAAY,EAAE;EACrD,MAAM,mBAAmB,EAAE,UAAU,EAAE;AACzC;;AAEA;EACE,OAAO,UAAU,EAAE,0BAA0B,EAAE;EAC/C,KAAK,UAAU,EAAE,wBAAwB,EAAE;AAC7C;;AAEA,gCAAgC;AAChC;EACE,kBAAkB;EAClB,WAAW;EACX,YAAY;EACZ,eAAe;EACf,gBAAgB;AAClB;;AAEA;;EAEE,WAAW;EACX,YAAY;EACZ,iBAAiB;EACjB,cAAc;AAChB;;AAEA;EACE,WAAW;EACX,YAAY;EACZ,aAAa;EACb,mBAAmB;EACnB,uBAAuB;EACvB,0CAA0C;EAC1C,wCAAwC;EACxC,eAAe;AACjB;;AAEA;EACE,kBAAkB;EAClB,WAAW;EACX,UAAU;EACV,8BAA8B;EAC9B,YAAY;EACZ,eAAe;EACf,gBAAgB;EAChB,kBAAkB;EAClB,oBAAoB;EACpB,UAAU;EACV,8BAA8B;AAChC;;AAEA;EACE,UAAU;AACZ","sourcesContent":["/* === Agent Workbench Design Tokens === */\n:root {\n  --aw-bg: #121212;\n  --aw-bg-sidebar: #0b0b0b;\n  --aw-bg-elevated: #1a1a1e;\n  --aw-bg-card: rgba(25, 25, 35, 0.5);\n  --aw-border: #2e2e2e;\n  --aw-border-soft: #1f1f23;\n  --aw-text: #ffffff;\n  --aw-text-secondary: #d1d1d6;\n  --aw-text-muted: #9ca3af;\n  --aw-text-dim: #666;\n  --aw-accent: #8b5cf6;\n  --aw-accent-alt: #a855f7;\n  --aw-accent-metric: #a78bfa;\n  --aw-accent-bg: rgba(139, 92, 246, 0.05);\n  --aw-accent-border: rgba(139, 92, 246, 0.2);\n  --aw-accent-tag-bg: rgba(168, 85, 247, 0.15);\n  --aw-qc: #eab308;\n  --aw-ua: #22c55e;\n  --aw-radius-sm: 8px;\n  --aw-radius-md: 12px;\n  --aw-radius-lg: 16px;\n  --aw-shadow-subtle: 0 4px 12px rgba(0,0,0,0.1);\n  --aw-shadow-medium: 0 4px 15px rgba(0,0,0,0.3);\n  --aw-shadow-strong: 0 10px 25px rgba(0,0,0,0.5);\n}\n\n/* Utility animations */\n@keyframes spin {\n  from { transform: rotate(0deg); }\n  to { transform: rotate(360deg); }\n}\n\n/* Reset */\n*, *::before, *::after {\n  box-sizing: border-box;\n}\n\nhtml, body, #root {\n  margin: 0;\n  padding: 0;\n  height: 100%;\n  overflow: hidden;\n}\n\nbody {\n  margin: 0;\n  font-family: 'Inter', -apple-system, BlinkMacSystemFont, 'Segoe UI', Roboto, Oxygen, Ubuntu, Cantarell, 'Fira Sans', 'Droid Sans', 'Helvetica Neue', sans-serif;\n  -webkit-font-smoothing: antialiased;\n  -moz-osx-font-smoothing: grayscale;\n  background: var(--aw-bg);\n  color: var(--aw-text);\n}\n\n/* ─── App Header (Artstash-style) ─── */\n.app-header {\n  display: flex;\n  align-items: center;\n  justify-content: space-between;\n  height: 48px;\n  padding: 6px 32px;\n  background-color: #333;\n  color: #f3f4f6;\n  flex-shrink: 0;\n  z-index: 100;\n}\n\n.app-header-left {\n  display: flex;\n  align-items: center;\n  gap: 0.5rem;\n  overflow: hidden;\n}\n\n.app-header-logo {\n  width: 94px;\n  height: 17px;\n  padding: 8px;\n  box-sizing: content-box;\n  flex-shrink: 0;\n}\n\n.app-header-divider {\n  width: 1px;\n  height: 24px;\n  background: rgba(255, 255, 255, 0.15);\n  margin: 0 0.25rem;\n  flex-shrink: 0;\n}\n\n.app-header-right {\n  display: flex;\n  align-items: center;\n  gap: 16px;\n  flex-shrink: 0;\n}\n\n.app-header-btn {\n  background: none;\n  border: none;\n  cursor: pointer;\n  padding: 0;\n  display: flex;\n  align-items: center;\n  justify-content: center;\n  width: 24px;\n  height: 24px;\n  border-radius: 50%;\n  color: #fff;\n  text-decoration: none;\n  transition: background-color 0.15s cubic-bezier(0.4, 0, 0.2, 1);\n}\n.app-header-btn:hover {\n  background-color: rgba(255, 255, 255, 0.08);\n}\n\n/* ─── User Avatar ─── */\n.header-user-avatar {\n  border: none;\n  padding: 0;\n  position: relative;\n  display: flex;\n  align-items: center;\n  justify-content: center;\n  flex-shrink: 0;\n  box-sizing: border-box;\n  width: 36px;\n  height: 36px;\n  border-radius: 50%;\n  overflow: hidden;\n  background-color: #66bb6a;\n  color: #121212;\n  font-family: stolzl, Arial, sans-serif;\n  font-size: 20px;\n  line-height: 20px;\n  font-weight: 400;\n  text-align: center;\n  cursor: pointer;\n  user-select: none;\n}\n\n.header-user-menu {\n  position: absolute;\n  top: calc(100% + 8px);\n  right: 0;\n  min-width: 200px;\n  background: #2a2a2e;\n  border: 1px solid #3e3e42;\n  border-radius: 8px;\n  padding: 4px;\n  box-shadow: 0 8px 24px rgba(0, 0, 0, 0.4);\n  z-index: 200;\n}\n\n.header-user-menu-info {\n  display: flex;\n  flex-direction: column;\n  padding: 8px 12px;\n  border-bottom: 1px solid #3e3e42;\n  margin-bottom: 4px;\n}\n\n.header-user-menu-name {\n  font-size: 0.8125rem;\n  font-weight: 500;\n  color: #fff;\n}\n\n.header-user-menu-email {\n  font-size: 0.75rem;\n  color: #9ca3af;\n}\n\n.header-user-menu-item {\n  display: flex;\n  align-items: center;\n  gap: 8px;\n  width: 100%;\n  padding: 8px 12px;\n  background: none;\n  border: none;\n  border-radius: 6px;\n  color: #e5e7eb;\n  font-size: 0.8125rem;\n  cursor: pointer;\n  transition: background 0.15s;\n}\n\n.header-user-menu-item:hover {\n  background: rgba(255, 255, 255, 0.08);\n}\n\n/* ─── App Switcher ─── */\n.header-app-switcher-menu {\n  position: absolute;\n  top: calc(100% + 20px);\n  right: 0;\n  min-width: 268px;\n  background: rgb(46,\t46,\t46);\n  border-radius: 4px;\n  box-shadow: 0 8px 24px rgba(0, 0, 0, 0.4);\n  z-index: 200;\n  font-family: stolzl, Arial, sans-serif;\n  font-weight: 400;\n}\n\n.header-app-switcher-item {\n  display: flex;\n  align-items: center;\n  gap: 8px;\n  width: 100%;\n  background: none;\n  border: none;\n  text-decoration: none;\n  cursor: pointer;\n  transition: background 0.15s;\n  padding: 10px 16px;\n  height: 48px;\n  color: #ffffff;\n  font-size: 1rem;\n}\n\n.header-app-switcher-item:hover {\n  background: rgba(255, 255, 255, 0.08);\n}\n\n.header-app-switcher-active {\n  color: #8b5cf6;\n}\n\n.header-app-switcher-icon {\n  width: 20px;\n  height: 20px;\n  display: inline-flex;\n  align-items: center;\n  justify-content: center;\n  flex-shrink: 0;\n}\n\n.header-app-switcher-icon svg {\n  display: block;\n  max-width: 100%;\n  max-height: 100%;\n}\n\n/* Header selector group */\n.app-header-selector {\n  display: flex;\n  align-items: center;\n  gap: 0.375rem;\n}\n\n.app-header-selector label {\n  font-family: stolzl, Arial, sans-serif;\n  font-weight: 500;\n  color: rgba(255, 255, 255, 0.5);\n  font-size: 0.6875rem;\n  text-transform: uppercase;\n  letter-spacing: 0.06em;\n  white-space: nowrap;\n}\n\n.app-header-selector select {\n  font-family: stolzl, Arial, sans-serif;\n  font-size: 0.8125rem;\n  font-weight: 400;\n  color: #fff;\n  background: transparent;\n  border: 1px solid rgba(255, 255, 255, 0.12);\n  border-radius: 6px;\n  padding: 0.25rem 1.75rem 0.25rem 0.5rem;\n  outline: none;\n  cursor: pointer;\n  -webkit-appearance: none;\n  -moz-appearance: none;\n  appearance: none;\n  background-image: url(\"data:image/svg+xml,%3Csvg width='10' height='6' viewBox='0 0 10 6' fill='none' xmlns='http://www.w3.org/2000/svg'%3E%3Cpath d='M1 1l4 4 4-4' stroke='%23999' stroke-width='1.5' stroke-linecap='round' stroke-linejoin='round'/%3E%3C/svg%3E\");\n  background-repeat: no-repeat;\n  background-position: right 0.5rem center;\n  transition: border-color 0.2s;\n}\n\n.app-header-selector select:hover {\n  border-color: rgba(255, 255, 255, 0.3);\n}\n\n.app-header-selector select:focus {\n  border-color: rgba(255, 255, 255, 0.4);\n}\n\n.app-header-selector select option {\n  background: #333;\n  color: #fff;\n}\n\n/* ─── Account and workspace navigation ─── */\n.context-navigation {\n  position: relative;\n  padding-bottom: 1rem;\n  margin-bottom: 1rem;\n  border-bottom: 1px solid var(--aw-border-soft);\n}\n\n.context-nav-label {\n  display: block;\n  margin-bottom: 0.375rem;\n  color: var(--aw-text-muted);\n  font-size: 0.6875rem;\n  font-weight: 600;\n  letter-spacing: 0.06em;\n  text-transform: uppercase;\n}\n\n.account-switcher {\n  position: relative;\n  margin-bottom: 1rem;\n}\n\n.account-switcher-trigger,\n.context-nav-option,\n.workspace-list-item {\n  width: 100%;\n  border: 0;\n  color: var(--aw-text-secondary);\n  font: inherit;\n  cursor: pointer;\n  text-align: left;\n}\n\n.account-switcher-trigger {\n  display: flex;\n  align-items: center;\n  justify-content: space-between;\n  gap: 0.5rem;\n  min-height: 38px;\n  padding: 0.5rem 0.625rem;\n  border: 1px solid var(--aw-border);\n  border-radius: 6px;\n  background: var(--aw-bg-elevated);\n}\n\n.account-switcher-trigger span {\n  overflow: hidden;\n  text-overflow: ellipsis;\n  white-space: nowrap;\n}\n\n.account-switcher-trigger:hover,\n.account-switcher-trigger:focus-visible {\n  border-color: var(--aw-accent);\n  outline: none;\n}\n\n.account-switcher-menu {\n  position: absolute;\n  top: calc(100% + 0.375rem);\n  left: 0;\n  right: 0;\n  z-index: 210;\n  padding: 0.375rem;\n  border: 1px solid var(--aw-border);\n  border-radius: 8px;\n  background: #202024;\n  box-shadow: var(--aw-shadow-strong);\n}\n\n.account-switcher-options {\n  max-height: 220px;\n  overflow-y: auto;\n}\n\n.context-search {\n  display: flex;\n  align-items: center;\n  gap: 0.5rem;\n  min-height: 36px;\n  padding: 0 0.625rem;\n  margin-bottom: 0.5rem;\n  border: 1px solid var(--aw-border);\n  border-radius: 6px;\n  background: var(--aw-bg);\n  color: var(--aw-text-muted);\n}\n\n.context-search:focus-within {\n  border-color: var(--aw-accent);\n}\n\n.context-search input {\n  width: 100%;\n  border: 0;\n  outline: 0;\n  background: transparent;\n  color: var(--aw-text);\n  font: inherit;\n  font-size: 0.8125rem;\n}\n\n.context-search input::placeholder {\n  color: var(--aw-text-dim);\n}\n\n.context-nav-option,\n.workspace-list-item {\n  padding: 0.5rem 0.625rem;\n  border-radius: 6px;\n  background: transparent;\n  font-size: 0.8125rem;\n  overflow: hidden;\n  text-overflow: ellipsis;\n  white-space: nowrap;\n}\n\n.context-nav-option:hover,\n.workspace-list-item:hover {\n  background: rgba(255, 255, 255, 0.05);\n}\n\n.context-nav-option.active,\n.workspace-list-item.active {\n  background: rgba(163, 112, 245, 0.12);\n  color: var(--aw-accent-metric);\n}\n\n.workspace-list {\n  max-height: 240px;\n  overflow-y: auto;\n}\n\n.context-nav-status,\n.context-nav-empty {\n  padding: 0.625rem;\n  color: var(--aw-text-dim);\n  font-size: 0.75rem;\n}\n\n.context-nav-error {\n  color: #ef4444;\n}\n\n.chat-context-header {\n  display: flex;\n  align-items: center;\n  justify-content: space-between;\n  gap: 1rem;\n  min-height: 64px;\n  padding: 0.625rem 1.25rem;\n  border-bottom: 1px solid var(--aw-border-soft);\n  background: var(--aw-bg-elevated);\n  flex-shrink: 0;\n}\n\n.chat-context-title {\n  min-width: 0;\n}\n\n.chat-context-title span {\n  display: block;\n  color: var(--aw-text-muted);\n  font-size: 0.6875rem;\n  line-height: 1rem;\n}\n\n.chat-context-title h1 {\n  margin: 0;\n  color: var(--aw-text);\n  font-size: 1rem;\n  line-height: 1.5rem;\n  overflow: hidden;\n  text-overflow: ellipsis;\n  white-space: nowrap;\n}\n\n.chat-context-header .app-header-selector {\n  flex-shrink: 0;\n}\n\n.chat-agent-controls {\n  display: flex;\n  align-items: center;\n  gap: 0.5rem;\n  flex-shrink: 0;\n}\n\n.agent-details-trigger {\n  position: relative;\n  display: inline-flex;\n  align-items: center;\n  gap: 0.375rem;\n  min-height: 32px;\n  padding: 0.25rem 0.625rem;\n  color: var(--aw-text);\n  background: transparent;\n  border: 1px solid rgba(255, 255, 255, 0.12);\n  border-radius: 6px;\n  font-family: stolzl, Arial, sans-serif;\n  font-size: 0.75rem;\n  cursor: pointer;\n}\n\n.agent-details-trigger:hover {\n  background: rgba(255, 255, 255, 0.06);\n  border-color: rgba(255, 255, 255, 0.3);\n}\n\n.agent-details-trigger:focus-visible,\n.agent-details-close:focus-visible {\n  outline: 2px solid #a370f5;\n  outline-offset: 2px;\n}\n\n.agent-details-warning {\n  display: inline-flex;\n  align-items: center;\n  justify-content: center;\n  color: #fbbf24;\n}\n\n.agent-details-backdrop {\n  position: fixed;\n  inset: 0;\n  z-index: 500;\n  display: flex;\n  align-items: center;\n  justify-content: center;\n  padding: 1rem;\n  background: rgba(0, 0, 0, 0.72);\n}\n\n.agent-details-dialog {\n  display: flex;\n  flex-direction: column;\n  width: min(560px, 100%);\n  max-height: min(760px, calc(100vh - 2rem));\n  overflow: hidden;\n  color: var(--aw-text);\n  background: var(--aw-bg);\n  border: 1px solid var(--aw-border);\n  border-radius: 10px;\n  box-shadow: 0 24px 64px rgba(0, 0, 0, 0.55);\n}\n\n.agent-details-dialog-header {\n  display: flex;\n  align-items: flex-start;\n  justify-content: space-between;\n  gap: 1rem;\n  padding: 1rem 1.25rem;\n  border-bottom: 1px solid var(--aw-border-soft);\n}\n\n.agent-details-dialog-header h2,\n.agent-details-dialog-header p {\n  margin: 0;\n}\n\n.agent-details-dialog-header h2 {\n  font-size: 1rem;\n  font-weight: 600;\n}\n\n.agent-details-dialog-header p {\n  margin-top: 0.125rem;\n  color: var(--aw-text-muted);\n  font-size: 0.75rem;\n}\n\n.agent-details-close {\n  display: inline-flex;\n  align-items: center;\n  justify-content: center;\n  width: 32px;\n  height: 32px;\n  flex-shrink: 0;\n  color: var(--aw-text-muted);\n  background: transparent;\n  border: none;\n  border-radius: 6px;\n  cursor: pointer;\n}\n\n.agent-details-close:hover {\n  color: var(--aw-text);\n  background: rgba(255, 255, 255, 0.08);\n}\n\n.agent-details-dialog-body {\n  overflow-y: auto;\n  padding: 0.75rem 1.25rem 1.25rem;\n}\n\n.agent-details-error {\n  display: flex;\n  align-items: flex-start;\n  gap: 0.5rem;\n  margin-top: 0.5rem;\n  padding: 0.75rem;\n  color: #ef4444;\n  background: rgba(239, 68, 68, 0.1);\n  border: 1px solid rgba(239, 68, 68, 0.2);\n  border-radius: 8px;\n  font-size: 0.75rem;\n}\n\n.agent-details-error strong {\n  display: block;\n  margin-bottom: 0.125rem;\n}\n\n/* ─── Artstash Buttons ─── */\n.aw-btn-primary {\n  display: inline-flex;\n  align-items: center;\n  justify-content: center;\n  font-family: stolzl, Arial, sans-serif;\n  font-size: 14px;\n  font-weight: 400;\n  line-height: 24px;\n  color: #fff;\n  background-color: #A370F5;\n  border: none;\n  border-radius: 4px;\n  padding: 6px 16px;\n  min-width: 64px;\n  cursor: pointer;\n  user-select: none;\n  text-transform: none;\n  text-decoration: none;\n  box-shadow: rgba(0,0,0,0.2) 0 3px 1px -2px, rgba(0,0,0,0.14) 0 2px 2px 0, rgba(0,0,0,0.12) 0 1px 5px 0;\n  transition: background-color 250ms cubic-bezier(0.4,0,0.2,1), box-shadow 250ms cubic-bezier(0.4,0,0.2,1);\n}\n.aw-btn-primary:hover {\n  background-color: #9260e0;\n}\n.aw-btn-primary:disabled {\n  opacity: 0.5;\n  cursor: not-allowed;\n}\n\n.aw-btn-secondary {\n  display: inline-flex;\n  align-items: center;\n  justify-content: center;\n  font-family: stolzl, Arial, sans-serif;\n  font-size: 14px;\n  font-weight: 400;\n  line-height: 24px;\n  color: #fff;\n  background-color: transparent;\n  border: 1px solid rgba(163, 112, 245, 0.5);\n  border-radius: 4px;\n  padding: 5px 15px;\n  min-width: 64px;\n  cursor: pointer;\n  user-select: none;\n  text-transform: none;\n  text-decoration: none;\n  transition: background-color 250ms cubic-bezier(0.4,0,0.2,1), border-color 250ms cubic-bezier(0.4,0,0.2,1);\n}\n.aw-btn-secondary:hover {\n  background-color: rgba(163, 112, 245, 0.08);\n  border-color: rgba(163, 112, 245, 0.7);\n}\n.aw-btn-secondary:disabled {\n  opacity: 0.5;\n  cursor: not-allowed;\n}\n\n/* Small variant for sidebar / compact areas */\n.aw-btn-primary.aw-btn-sm,\n.aw-btn-secondary.aw-btn-sm {\n  font-size: 0.75rem;\n  padding: 4px 12px;\n  min-width: unset;\n  line-height: 1.5;\n}\n\n/* ─── Session List (workspace-style) ─── */\n.session-list-header {\n  display: flex;\n  justify-content: space-between;\n  align-items: center;\n  padding: 0 0.25rem;\n  margin-bottom: 0.25rem;\n}\n\n.session-list-header h4 {\n  margin: 0;\n  font-family: stolzl, Arial, sans-serif;\n  font-size: 0.75rem;\n  font-weight: 500;\n  color: #6b7280;\n  text-transform: uppercase;\n  letter-spacing: 0.04em;\n}\n\n.session-list-items {\n  list-style: none;\n  padding: 0;\n  margin: 0;\n}\n\n.session-list-item {\n  display: flex;\n  align-items: center;\n  width: 100%;\n  padding: 8px 12px;\n  font-family: stolzl, Arial, sans-serif;\n  font-size: 0.8125rem;\n  font-weight: 400;\n  line-height: 1.5;\n  color: #d1d1d6;\n  background: transparent;\n  border: none;\n  border-radius: 4px;\n  cursor: pointer;\n  text-align: left;\n  white-space: nowrap;\n  overflow: hidden;\n  text-overflow: ellipsis;\n  transition: background-color 250ms cubic-bezier(0.4,0,0.2,1);\n}\n\n.session-list-item:hover {\n  background-color: rgba(255, 255, 255, 0.04);\n}\n\n.session-list-item.active {\n  background-color: rgba(163, 112, 245, 0.12);\n  color: #A370F5;\n}\n\ncode {\n  font-family: source-code-pro, Menlo, Monaco, Consolas, 'Courier New',\n    monospace;\n}\n\n/* Fix chat layout and code display */\n.chat-area {\n  max-width: 100vw;\n  overflow-x: hidden;\n}\n\n.messages-list {\n  width: 100%;\n  box-sizing: border-box;\n}\n\n/* Markdown Code Blocks */\npre {\n  background-color: #0d0d0d;\n  color: #d4d4d4;\n  padding: 1rem;\n  border-radius: var(--aw-radius-sm);\n  border: 1px solid var(--aw-border-soft);\n  overflow-x: auto;\n  margin: 0.5rem 0;\n  max-width: 100%;\n}\n\npre code {\n  background-color: transparent;\n  padding: 0;\n  border-radius: 0;\n  color: inherit;\n}\n\n/* Inline code */\np code {\n  background-color: var(--aw-accent-tag-bg);\n  padding: 0.2rem 0.4rem;\n  border-radius: 4px;\n  font-size: 0.875em;\n  color: var(--aw-accent-alt);\n}\n\n/* Ensure message bubbles don't overflow */\n.message-bubble {\n  max-width: 100%;\n  overflow-wrap: break-word;\n}\n.message-bubble img {\n  max-width: 100%;\n  height: auto;\n}\n\n/* Markdown links */\n.message-bubble a {\n  color: var(--aw-accent-metric);\n  text-decoration: underline;\n  text-decoration-color: rgba(167, 139, 250, 0.4);\n}\n.message-bubble a:hover {\n  color: var(--aw-accent-alt);\n}\n\n/* Large Asset Grid */\n.assets-grid {\n  display: grid;\n  grid-template-columns: repeat(auto-fill, minmax(300px, 1fr));\n  gap: 1rem;\n  margin-top: 0.5rem;\n  max-height: 600px;\n  overflow-y: auto;\n  padding-right: 0.25rem;\n}\n\n.asset-card {\n  display: flex;\n  flex-direction: column;\n  background: var(--aw-bg-elevated);\n  border: 1px solid var(--aw-border);\n  border-radius: var(--aw-radius-md);\n  padding: 0;\n  gap: 0;\n  align-items: stretch;\n  transition: box-shadow 0.2s, border-color 0.2s;\n  overflow: hidden;\n}\n\n.asset-card:hover {\n  box-shadow: var(--aw-shadow-medium);\n  border-color: var(--aw-accent-border);\n}\n\n.asset-card .thumbnail {\n  width: 100%;\n  height: 200px;\n  flex-shrink: 0;\n  background: #0d0d0d;\n  display: flex;\n  align-items: center;\n  justify-content: center;\n  overflow: hidden;\n  color: var(--aw-text-muted);\n  position: relative;\n}\n\n.asset-card .thumbnail img {\n  width: 100%;\n  height: 100%;\n  object-fit: cover;\n}\n\n.asset-card .details {\n  padding: 1rem;\n  flex: 1;\n  min-width: 0;\n  display: flex;\n  flex-direction: column;\n  gap: 0.5rem;\n}\n\n.asset-card .details h4 {\n  margin: 0;\n  font-size: 0.9rem;\n  white-space: nowrap;\n  overflow: hidden;\n  text-overflow: ellipsis;\n  font-weight: 600;\n  color: var(--aw-text);\n}\n\n.asset-card .details .tags {\n  display: flex;\n  gap: 0.25rem;\n  flex-wrap: wrap;\n}\n\n.asset-card .details .tags span {\n  display: inline-flex;\n  align-items: center;\n  height: 22px;\n  padding: 0 0.5rem;\n  border: 1px solid #464646;\n  border-radius: 11px;\n  font-family: stolzl, Arial, sans-serif;\n  font-size: 0.6875rem;\n  font-weight: 400;\n  color: #fff;\n  background: transparent;\n  white-space: nowrap;\n}\n\n.asset-card button {\n  align-self: flex-start;\n  background: var(--aw-accent);\n  color: white;\n  border: none;\n  padding: 0.2rem 0.5rem;\n  border-radius: 4px;\n  font-size: 0.75rem;\n  cursor: pointer;\n  transition: background 0.2s;\n}\n\n.asset-card button:hover {\n  background: var(--aw-accent-alt);\n}\n\n.asset-card .thumbnail-loading,\n.asset-card .thumbnail-error {\n  display: flex;\n  flex-direction: column;\n  align-items: center;\n  justify-content: center;\n  gap: 0.5rem;\n  color: var(--aw-text-muted);\n  font-size: 0.75rem;\n}\n\n.asset-card .thumbnail-error {\n  color: #ef4444;\n}\n\n.asset-card .video-badge {\n  position: absolute;\n  top: 8px;\n  right: 8px;\n  background: rgba(0, 0, 0, 0.7);\n  border-radius: 4px;\n  padding: 4px;\n  color: white;\n  display: flex;\n  align-items: center;\n}\n\n.asset-card .media-type-badge {\n  display: inline-block;\n  font-size: 0.65rem;\n  text-transform: uppercase;\n  letter-spacing: 0.5px;\n  color: var(--aw-text-muted);\n  background: var(--aw-bg-hover);\n  padding: 0.1rem 0.4rem;\n  border-radius: 3px;\n  width: fit-content;\n}\n\n.asset-card .asset-icon {\n  opacity: 0.5;\n}\n\n/* Inline asset images in chat messages */\n.inline-asset {\n  display: block;\n  margin: 0.75rem 0;\n}\n\n/* Strip list bullets when items contain inline asset cards */\n.message-bubble li:has(.inline-asset) {\n  list-style: none;\n}\n.message-bubble ul:has(.inline-asset),\n.message-bubble ol:has(.inline-asset) {\n  padding-left: 0;\n}\n\n.inline-asset-link {\n  text-decoration: none;\n  color: inherit;\n  display: block;\n  border-radius: 8px;\n  overflow: hidden;\n  border: 1px solid var(--aw-border, #2e2e2e);\n  transition: border-color 0.2s, box-shadow 0.2s;\n  background: #0d0d0d;\n  max-width: 480px;\n}\n\n.inline-asset-link:hover {\n  border-color: var(--aw-accent-border, #8b5cf6);\n  box-shadow: 0 2px 12px rgba(139, 92, 246, 0.15);\n}\n\n.inline-asset-image-wrapper {\n  display: block;\n  position: relative;\n  max-height: 300px;\n  max-width: 480px;\n  overflow: hidden;\n}\n\n.inline-asset-image {\n  display: block;\n  width: 100%;\n  max-height: 300px;\n  object-fit: cover;\n}\n\n.inline-asset-video-badge {\n  position: absolute;\n  top: 50%;\n  left: 50%;\n  transform: translate(-50%, -50%);\n  background: rgba(0, 0, 0, 0.6);\n  border-radius: 50%;\n  padding: 8px;\n  color: white;\n  display: flex;\n  align-items: center;\n  justify-content: center;\n}\n\n.inline-asset-placeholder {\n  display: flex;\n  align-items: center;\n  justify-content: center;\n  height: 120px;\n  color: var(--aw-text-muted, #6b7280);\n  opacity: 0.5;\n}\n\n.inline-asset-caption {\n  display: flex;\n  align-items: center;\n  gap: 0.5rem;\n  padding: 0.5rem 0.75rem;\n  font-size: 0.8rem;\n  color: var(--aw-text-muted, #9ca3af);\n  border-top: 1px solid var(--aw-border, #2e2e2e);\n}\n\n.inline-asset-name {\n  flex: 1;\n  overflow: hidden;\n  text-overflow: ellipsis;\n  white-space: nowrap;\n}\n\n.inline-asset-tags {\n  display: flex;\n  gap: 0.25rem;\n  flex-wrap: wrap;\n  padding: 0.25rem 0.75rem 0.5rem;\n}\n\n.inline-asset-tags .tag {\n  display: inline-flex;\n  align-items: center;\n  height: 22px;\n  padding: 0 0.5rem;\n  border: 1px solid #464646;\n  border-radius: 11px;\n  font-family: stolzl, Arial, sans-serif;\n  font-size: 0.6875rem;\n  font-weight: 400;\n  color: #fff;\n  background: transparent;\n  white-space: nowrap;\n  transition: background-color 0.3s cubic-bezier(0.4, 0, 0.2, 1);\n}\n\n/* Scrollbar styling */\n::-webkit-scrollbar {\n  width: 6px;\n}\n::-webkit-scrollbar-track {\n  background: transparent;\n}\n::-webkit-scrollbar-thumb {\n  background: var(--aw-border);\n  border-radius: 3px;\n}\n::-webkit-scrollbar-thumb:hover {\n  background: #444;\n}\n\n/* Select / dropdown dark styling */\nselect, input[type=\"text\"], textarea {\n  color-scheme: dark;\n}\n\n/* Thinking Indicator */\n.thinking-indicator {\n  display: inline-flex;\n  align-items: center;\n  gap: 0.5rem;\n  background: #1a1a1e !important;\n  border: 1px solid #2e2e2e !important;\n  padding: 0.6rem 1rem !important;\n  border-radius: 12px;\n  animation: thinking-fade-in 0.2s ease-out;\n}\n\n.thinking-label {\n  font-size: 0.875rem;\n  color: #9ca3af;\n}\n\n.thinking-dots {\n  display: inline-flex;\n  gap: 3px;\n  align-items: center;\n}\n\n.thinking-dots .dot {\n  width: 5px;\n  height: 5px;\n  border-radius: 50%;\n  background: #8b5cf6;\n  animation: thinking-bounce 1.4s infinite ease-in-out both;\n}\n\n.thinking-dots .dot:nth-child(1) { animation-delay: 0s; }\n.thinking-dots .dot:nth-child(2) { animation-delay: 0.16s; }\n.thinking-dots .dot:nth-child(3) { animation-delay: 0.32s; }\n\n@keyframes thinking-bounce {\n  0%, 80%, 100% { transform: scale(0.6); opacity: 0.4; }\n  40% { transform: scale(1); opacity: 1; }\n}\n\n@keyframes thinking-fade-in {\n  from { opacity: 0; transform: translateY(4px); }\n  to { opacity: 1; transform: translateY(0); }\n}\n\n/* === Video Scrub Preview === */\n.video-scrub-container {\n  position: relative;\n  width: 100%;\n  height: 100%;\n  cursor: pointer;\n  overflow: hidden;\n}\n\n.video-scrub-image,\n.video-scrub-video {\n  width: 100%;\n  height: 100%;\n  object-fit: cover;\n  display: block;\n}\n\n.video-scrub-placeholder {\n  width: 100%;\n  height: 100%;\n  display: flex;\n  align-items: center;\n  justify-content: center;\n  background: var(--aw-bg-elevated, #1a1a1e);\n  color: var(--aw-text-secondary, #d1d1d6);\n  font-size: 2rem;\n}\n\n.video-scrub-badge {\n  position: absolute;\n  bottom: 6px;\n  right: 6px;\n  background: rgba(0, 0, 0, 0.6);\n  color: white;\n  font-size: 10px;\n  padding: 2px 6px;\n  border-radius: 4px;\n  pointer-events: none;\n  z-index: 2;\n  transition: opacity 0.15s ease;\n}\n\n.video-scrub-container:hover .video-scrub-badge {\n  opacity: 0;\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
